
<template lang="pug">
	.container-fluid.animated.fadeIn.pb-4

		div.bg-light.filterBlock
			.g-between-center
				h5.mb-0
					| Фильтр
				div.g-v-center
					span.mr-1(v-if="activeFiltersCount") {{ activeFiltersCount }}
					b-button(v-b-toggle.collapse-2 size="sm" :variant="activeFiltersCount?'success':''")
						i.icon-equalizer
					b-button.ml-2(v-if="activeFiltersCount" @click="resetFilter" size="sm" variant="danger" v-b-tooltip.hover.left="'очистить'")
						i.fa.fa-lg.fa-rotate-left

			b-collapse(id="collapse-2")
				b-row(style="padding-top:10px")
					b-col(cols="12" md="3")
						b-form-input.mb-2.mb-md-0.w-100(type='text' v-model='search.title' placeholder='Название документа')
					b-col(cols="12" md="3")
						b-form-select.mb-2.mb-md-0.w-100(type="select" v-model='search.tag'  placeholder='Тег' :options="selectOptions")

		h2.mt-4.mb-3.g-between-center
			| {{ _pageHeading }}
			b-badge.ml-1(variant="primary" v-if="resources.data.count" style="font-size:1rem; font-weight:400;") {{ resources.data.count }}

		NothingFound(v-if="!resources.isFetching && resources.data.count===0")

		transition(name="list-complete")
			b-card-group(else columns style="column-gap: 15px;"  v-if="!resources.isFetching && !resources.error")
				ResourceCard(v-for="post in resourcesResults" :key="post.id" :_post="post" :_baseUrl="_baseUrl")

		b-pagination.mt-4(v-model="curPage" :total-rows="resources.data.count" :per-page="_perPage" align="center" @input="fetchResources" v-if="resources.data.count>_perPage")

		preloader_v2(:_object="resources")

</template>

<script>
	import {mapState} from 'vuex'

	import ResourceCard from '../components/cards/ResourceCard';

	import parseUrlMixin from '../../MIXINS/parseUrl';

	import selectIterfacer from '../../utility/Interfacers/select'

	export default {
		name: 'Info',
		props: ['_baseUrl','_catID','_perPage','_pageHeading','_fields'],
		components: {ResourceCard,},
		mixins: [ parseUrlMixin ],
		data: () => ({
			curPage: 1,
			search: {
				title: '',
				tag: null,
			},
			timer: null,
		}),
		watch: {
			search: {
				handler(){
					clearInterval(this.timer);
					this.timer = setInterval( () => clearInterval(this.timer)||this.fetchResources(1), 500 );
				},
				deep: true,
			}
		},
		computed: {
			...mapState(['resources', 'tags']),
			resourcesResults(){ return this.resources.data.results || [] },

			tagsList(){ return this.tags.data.results || [] },
			activeFiltersCount(){
				return Object.values(this.search).reduce( (acc,item) => item ? ++acc : acc, 0);
			},
			filterObj(){
				return Object.keys(this.search).reduce( (acc,item) =>
					(this.search[item] ? ({...acc, [item]:this.search[item]}) : {...acc}), {});
			},
			selectOptions(){ return selectIterfacer( this.tagsList, ['title','id'], [{ text: 'Тег', value: null }]) },
		},
		methods: {
			resetFilter(){
				this.search = this.$options.data.call(this).search;
				this.$router.push({ path: ''})
			},
			fetchResources(curPage){
				if ( curPage ) this.curPage = curPage;

				this.$store.dispatch('getResources',
					{ limit:this._perPage, offset:this._perPage*(this.curPage - 1), fields:this._fields, category__id:this._catID, ...this.filterObj }
				)
			},
			setFromQuery(){
				if ( this.$route.query.tag ) { this.search.tag = this.$route.query.tag }
			},
		},
		beforeMount(){
			this.setFromQuery();
			this.$store.dispatch('getTags');
		},
	}
</script>
<style lang="scss">
	.filterBlock {
		position: -webkit-sticky;
		position: sticky;
		top: 55px;
		z-index: 100;
		margin: 0 -20px;
		padding: 10px 15px
	}
	// -----------------------
	.list-complete-enter {
		opacity: 0;
		transform: translateY(50px);
		transition: all .5s ease;
	}
	.list-complete-enter-to {}
	.list-complete-enter-active {
		transition: all .8s ease;
	}

	.list-complete-leave {

	}
	.list-complete-leave-to {
		opacity: 0;
		transform: translateX(50px);
		transition: all .5s ease;
	}
	.list-complete-leave-active {
		transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	// -----------------------
</style>
